import { connect } from 'react-redux';
import { applySpec, compose } from 'ramda';
import { withTranslation } from 'react-i18next';
import { isSuperResearcher, isSuperTechnician, isResearcher } from 'store/selectors/user';
import Alerts from './Alerts';

const mapStateToProps = applySpec({
  isSuperResearcher,
  isSuperTechnician,
  isResearcher,
});

export default compose(
  connect(mapStateToProps),
  withTranslation(),
)(Alerts);
